const initHeroParalax = () => {
    window.addEventListener("scroll", function () {
        var scrolled = window.scrollY;
        var viewportHeight = window.innerHeight;

        // Calculate opacity based on screen height. Opacity will go from 1 to 0 as you scroll down one viewport height
        var opacity = 1 - scrolled / viewportHeight;

        // Make nebula layer scroll slower than the content layer
        var nebulaOffset = scrolled * 0.3;
        var nebulaLayer = document.querySelector('.nebula-layer');
        nebulaLayer.style.transform = 'translate3d(0,' + nebulaOffset + 'px, 0)';
        nebulaLayer.style.opacity = Math.max(opacity, 0); // Ensure opacity doesn't go negative

        // Make stars layer scroll slower than the nebula layer
        var starsOffset = scrolled * 0.9;
        var starsLayer = document.querySelector('.stars-layer');
        starsLayer.style.transform = 'translate3d(0,' + starsOffset + 'px, 0)';
        starsLayer.style.opacity = Math.max(opacity * 0.8, 0); // Ensure opacity doesn't go negative
    });
}
export { initHeroParalax };

const initFooterParalax = () => {
    window.addEventListener("scroll", function () {
        var scrolled = window.scrollY;
        var viewportHeight = window.innerHeight;
        var documentHeight = document.documentElement.scrollHeight;

        // Calculate how close we are to the bottom
        var distanceToBottom = documentHeight - (scrolled + viewportHeight);

        // Calculate opacity based on closeness to the bottom
        var endOpacity = 1 - Math.max(0, distanceToBottom / viewportHeight); // Ensure opacity doesn't go negative

        // Calculate transform based on closeness to the bottom. Start translated up (-100px) and move to original position (0px)
        var initialOffset = -500;
        var starsOffset = initialOffset + (500 * (1 - distanceToBottom / viewportHeight)); // Calculate new offset

        // Select the stars-layer-footer
        var starsLayerFooter = document.querySelector('.stars-layer-footer');

        if (starsLayerFooter) {
            starsLayerFooter.style.transform = 'translate3d(0,' + starsOffset + 'px, 0)';
            starsLayerFooter.style.opacity = Math.min(endOpacity, 1);  // Ensure opacity doesn't exceed 1
        }
    });
}
// If you're using ES6 modules
export { initFooterParalax };

const initBodyParalax = () => {
    window.addEventListener("scroll", onScroll, { passive: true });

    function onScroll() {
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        const parallaxElements = document.querySelectorAll('.js-parallax');

        parallaxElements.forEach(element => {
            const bounding = element.getBoundingClientRect();
            const distanceToCenter = bounding.top + bounding.height / 2 - viewportHeight / 2;
            const normalizedDistance = distanceToCenter / (viewportHeight / 2);
            const translateFactor = 150; //viewportWidth > 1024 ? 150 : 150; // updated mobile factor
            const calculatedTranslateY = normalizedDistance * -translateFactor;
            const calculatedOpacity = Math.max(1 + normalizedDistance, 0);

            element.style.transform = `translateY(${calculatedTranslateY}px)`;
            element.style.opacity = calculatedOpacity.toString();
        });
    }
}

export { initBodyParalax };